import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { PrivateMenu } from '.';
import images from '../../../assets/images/images';
import { Image } from '../../';
import { cn } from '../../../helpers/className';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { ConfigContext } from '../../../providers';
import { logoutUser } from '../../../redux/user/actions';

import styles from './headermenu.module.scss';
import { getUserInfo } from '../../../services/login.service';
import { staticConfig } from '../../../config/static';
import { closePopupOFocusOut } from '../../../helpers/general';

const { active, headerMenu } = styles;

export const HeaderMenu = (): JSX.Element => {
    const dispatch = useDispatch();
    const config = useContext(ConfigContext);

    const { formatMessage } = useIntl();

    const [showMenu, setShowMenu] = useState<boolean>(false);
    // const [showPrivateMenu, setShowPrivateMenu] = useState<boolean>(false);
    // const [showPublicMenu, setShowPublicMenu] = useState<boolean>(true);

    const toggleDropdown = (): void => {
        setShowMenu(!showMenu);
    };

    // const togglePrivateMenu = (): void => {
    //     setShowPublicMenu(false);
    //     setShowPrivateMenu(!showPrivateMenu);
    // };

    // const togglePublicMenu = (): void => {
    //     setShowPrivateMenu(false);
    //     setShowPublicMenu(!showPublicMenu);
    // };

    const hideMenu = (): void => {
        setShowMenu(false);
    };

    const onEsckey = (e: any) => {
        if (e.key == 'Escape' || e.keyCode == 27) {
            setShowMenu(false);
        }
    };
    const logout = (): void => {
        getUserInfo().then((res) => {
            dispatch(logoutUser());
        });
    };

    const menuRef = useClickOutside<HTMLDivElement>(hideMenu);

    const menuText = formatMessage({ id: 'MENU' });

    return (
        <div
            className={cn(headerMenu, showMenu && active)}
            ref={menuRef}
            {...{
                onKeyDown: (e) => {
                    onEsckey(e);
                },
            }}
        >
            <button
                className="d-flex align-items-center justify-content-center"
                aria-haspopup="menu"
                aria-expanded={showMenu}
                aria-label={menuText}
                onClick={toggleDropdown}
                onBlur={(e) => {
                    closePopupOFocusOut(e, true) && setShowMenu(false);
                }}
            >
                <Image className={styles.menuButtonIcon} src={images.burgerMenu} alt="MENU" />

                <span className="d-none d-md-inline-block">
                    {menuText}&nbsp;&nbsp;
                    <Image
                        className={styles.dropDownIcon}
                        src={showMenu ? images.upArrow : images.downArrow}
                        alt="DROPDOWN"
                    />
                </span>
            </button>

            {!showMenu! ? null : (
                <ul className="list-unstyled d-flex flex-column">
                    {!staticConfig.isclassicunavailable ? (
                        <li className="d-flex flex-column">
                            {/* <SubMenu
                                onClick={togglePrivateMenu}
                                subTitle={formatMessage({ id: 'MENU_MAIL_SUBTITLE_PRIVATE' })}
                                title={formatMessage({ id: 'MENU_MAIL_TITLE_PRIVATE' })}
                                toggled={showPrivateMenu}
                            >
                            </SubMenu> */}
                            <PrivateMenu toggleDropdown={toggleDropdown} />
                        </li>
                    ) : null}

                    {/* <li className="d-flex flex-column">
                        <SubMenu
                            onClick={togglePublicMenu}
                            subTitle={formatMessage({ id: 'MENU_MAIL_SUBTITLE_PUBLIC' })}
                            title={formatMessage({ id: 'MENU_MAIL_TITLE_PUBLIC' })}
                            toggled={showPublicMenu}
                        >
                        </SubMenu>
                            <PublicMenu onNavigation={hideMenu} />
                    </li> */}

                    <li className="d-flex d-md-none flex-column">
                        <a href={config?.links?.header?.help?.link} target="_blank" rel="noopener noreferrer">
                            {formatMessage({ id: 'HELP' })}
                        </a>
                    </li>

                    <li className="d-flex d-md-none flex-column">
                        <button className={styles.logoutButton} onClick={logout}>
                            <span>{formatMessage({ id: 'LOG_OFF' })}</span>
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
};
